/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/network-1214308': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 15a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm4-3a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zm8-8a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v10a1 1 0 002 0V9a1 1 0 00-1-1z"/>'
  }
})
